import MobileDetect from "mobile-detect"

const mobileDetect = new MobileDetect(window.navigator.userAgent)

export const isMobile = mobileDetect.mobile() ? true : false
export const isDeviceIPhone = mobileDetect.mobile() === `iPhone`
export const isBrowserSafari = mobileDetect.userAgent() === `Safari`
